import * as S from './ErrorMessage.styles'

function ErrorMessage({ message }) {
  return (
    <S.Container data-testid="error-message">
      <S.Message>{message}</S.Message>
    </S.Container>
  )
}

export default ErrorMessage
